import { render, staticRenderFns } from "./PatientFileForm.vue?vue&type=template&id=460bddde&"
import script from "./PatientFileForm.vue?vue&type=script&lang=js&"
export * from "./PatientFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports